/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

const VERSION_POLL_MS = 5 * 60 * 1000

const showReloadBanner = () => {
  if (document.getElementById(`bp-update-banner`)) return

  const banner = document.createElement(`div`)
  banner.id = `bp-update-banner`
  banner.setAttribute(`role`, `status`)
  banner.style.cssText = `
    position:fixed;bottom:1rem;left:50%;transform:translateX(-50%);z-index:9999;
    display:flex;gap:.75rem;align-items:center;padding:.75rem 1rem;border-radius:.5rem;
    background:#1f2937;color:#fff;font:14px/1.4 system-ui,sans-serif;
    box-shadow:0 4px 12px rgba(0,0,0,.25);
  `

  const text = document.createElement(`span`)
  text.textContent = `A new version is available.`

  const button = document.createElement(`button`)
  button.type = `button`
  button.textContent = `Reload`
  button.style.cssText = `
    padding:.35rem .75rem;border:0;border-radius:.25rem;
    background:#fff;color:#1f2937;font-weight:600;cursor:pointer;
  `
  button.addEventListener(`click`, () => window.location.reload())

  banner.append(text, button)
  document.body.appendChild(banner)
}

// onClientEntry runs once when the browser runtime first starts.
// (The previous name, onInitialClientEntry, is not a real Gatsby API and
// triggered ERROR #11329 API.NODE.VALIDATION on every dev/build startup.)
export const onClientEntry = () => {
  if (process.env.NODE_ENV !== `production`) return

  const checkForNewBuild = async () => {
    if (document.visibilityState !== `visible`) return

    try {
      // cache: no-store so this never reads the copy CloudFront or the browser
      // already has — a stale hash here defeats the entire check.
      const response = await fetch(`/page-data/app-data.json`, {
        cache: `no-store`,
      })
      if (!response.ok) return

      const { webpackCompilationHash } = await response.json()
      if (
        webpackCompilationHash &&
        webpackCompilationHash !== window.___webpackCompilationHash
      ) {
        clearInterval(intervalId)
        showReloadBanner()
      }
    } catch {
      // Offline or a transient failure; the next tick retries.
    }
  }

  const intervalId = setInterval(checkForNewBuild, VERSION_POLL_MS)
}
